import { lazy } from 'react';
// import AddServiceRequest from '../pages/addServiceRequest.page';

// ----------------------------------------------------------------------

const ServiceListPage = lazy(() => import('../pages/OrderList.page'));
const CourseDetailsPage = lazy(() => import('../pages/CourseDetails.page'));

// ----------------------------------------------------------------------

const ServiceListRoutes = [
    {
        path: '/courses',
        children: [
            { element: <ServiceListPage />, layout: 'default', isAuthReq: true, index: true },
            { path: ':id', element: <CourseDetailsPage />, layout: 'default', isAuthReq: true },
            // {
            //     path: '/services/service-request',
            //     element: <AddServiceRequest />,
            //     layout: 'default',
            //     isAuthReq: true,
            // },
        ],
    },
];

export { ServiceListRoutes };
